import { Component, OnDestroy } from '@angular/core';
import { NiceSdkAuthenticationService } from '../../data/CXOne/sdk-auth/nice-sdk-authentication.service';
import { SdkAcdAgent } from '../../data/CXOne/sdk-acd/sdk-acd.service';
import { LoggerService } from '../../core/services/logger.service';
import { DynamicsService } from '../../data/Dynamics/dynamics.service';
// import { CXoneVoiceClient } from '@nice-devone/voice-sdk';
import { LoginService } from '../../core/services/login.service';
import { CXoneClient } from '@nice-devone/agent-sdk';
import { AgentSettings } from '@nice-devone/core-sdk';
import { UserInfo } from '@nice-devone/common-sdk';
import { CXoneVoiceContact } from '@nice-devone/acd-sdk';
import { EventHandlerService } from 'src/app/data/services/event-handler.service';
import { VoiceContactStatusAgent } from 'src/app/shared/enums/voice-contact-status-agent.enum';
import { IframeEnvironment } from 'src/app/core/services/util.service';
import { NiceSessionManagementService } from 'src/app/shared/services/nice-session-management/nice-session-management.service';
import { GenericModalService } from 'src/app/shared/services/generic-modal.service';
import { ContactCenterConsultoresPFService } from 'src/app/data/CXOne/services/contact-center-consultores-seguros-pf';
import { DigitalSessionEndReason } from 'src/app/data/CXOne/DataTransferObjects/DigitalEventDTO';
import { LocalStorageUtils } from 'src/app/data/CXOne/util/LocalStorageUtils';
import { JsonConverterUtils } from 'src/app/data/CXOne/util/JsonConverterUtils';
import { quickWebLogger } from '@quickweb/logger';
import { getUserIfoInLocalStorage } from 'src/app/utils/get-user-info-In-localstorage';

const TITULO_POR_ORIGEM: Record<string, string> = {
  fastpass: 'Fast Pass',
  receptivo: 'Receptivo',
};

@Component({
  selector: 'app-seguros-pf',
  standalone: true,
  imports: [],
  templateUrl: './seguros-pf.component.html',
  styleUrl: './seguros-pf.component.css',
})
export class SegurosPfComponent implements OnDestroy {
  private readonly localStorageUtils = new LocalStorageUtils();
  private readonly jsonConverterUtils = new JsonConverterUtils();

  constructor(
    private niceSdkAuthService: NiceSdkAuthenticationService,
    private sdkAcdAgent: SdkAcdAgent,
    private logger: LoggerService,
    private dynamics: DynamicsService,
    private loginService: LoginService,
    private eventHandler: EventHandlerService,
    private genricModal: GenericModalService,
    private niceSessionManagementService: NiceSessionManagementService,
    private contactCenterConsultoresPFService: ContactCenterConsultoresPFService,
  ) {}

  ngOnDestroy(): void {
    window.removeEventListener('message', this.messageHandler);
  }

  async ngOnInit() {
    this.logger.info('Starting Seguros PF Component...');
    const centralId =
      this.localStorageUtils.safeGetItem('centralId') || 'seguros-pf';
    const authServiceType =
      this.localStorageUtils.safeGetItem('authServiceType') || 'nice';
    const authMode =
      this.localStorageUtils.safeGetItem('display_mode') || 'popup';
    const sessionIsExpired =
      this.niceSessionManagementService.checkNiceSessionExpiration();
    if (sessionIsExpired === false) {
      this.genricModal.createModal({
        title: 'Outra aba da Nice já está ativa',
        allowCloseModal: false,
        description:
          'Detectamos que você já possui uma aba da Nice aberta. Por favor, utilize a aba existente para continuar',
      });
      return;
    }

    try {
      const isAuthenticated = await this.loginService.login(
        authServiceType,
        centralId,
        true,
        authMode,
      );
      if (isAuthenticated) {
        this.logger.info('User Authenticated.');
        await this.niceSdkAuthService.launchAgent();
        this.sdkAcdAgent.initialize();
        await this.dynamics.initialize();
        this.niceSessionManagementService.updateNiceSession();
        this.sdkAcdAgent.agentState$.subscribe((agentState) => {
          this.logger.info('Agent State: ', agentState);
        });

        this.sdkAcdAgent.voiceContactUpdate$.subscribe(
          (voiceContact: CXoneVoiceContact) => {
            const status = voiceContact.status || '';
            const contactId = voiceContact.contactID || '';
            const contatoEvento = { id: contactId, status: status };
            let eventoProcessado = this.eventHandler.isProcessed(contatoEvento);
            this.logger.info(
              'Voice Contact status (',
              status,
              ') evento: ',
              voiceContact,
            );

            if (!eventoProcessado) {
              this.eventHandler.add(contatoEvento);
            }

            if (
              status === VoiceContactStatusAgent.DISCONNECTED &&
              eventoProcessado
            ) {
              this.eventHandler.remove(contatoEvento);
              this.InsertTimeLineDynamics(voiceContact);
            }
          },
        );

        this.contactCenterConsultoresPFService.initializer();

        this.contactCenterConsultoresPFService.onAttachedEvent$.subscribe(
          async (event) => {
            const dynamicsData =
              this.contactCenterConsultoresPFService.formatNiceDataToDynamcis(
                event,
              );
            if (dynamicsData === null) return;

            this.createDigitalRecordInDynamcis(dynamicsData, event.contactId);
          },
        );

        this.contactCenterConsultoresPFService.onFocusEvent$.subscribe(
          async (event) => {
            const dynamicsData =
              this.contactCenterConsultoresPFService.formatNiceDataToDynamcis(
                event,
              );

            this.logger.info(
              'attached data formatad => ',
              JSON.stringify(dynamicsData),
            );

            if (dynamicsData === null) return;

            await this.raiseContactFocusEventOnDynamics(
              dynamicsData,
              event.contactId,
            );
          },
        );

        this.contactCenterConsultoresPFService.onDigitalSessionEvent$.subscribe(
          (event) => {
            if (event.SessionEndReason === DigitalSessionEndReason.Closed) {
              const dynamcsData = {
                u_json: {
                  NICE_CONTACT_ID: event.Id,
                },
              };

              this.closeDynamicLeadTimeLine(dynamcsData);
            }
          },
        );

        window.addEventListener('message', this.messageHandler);
      } else {
        this.logger.info('User not authenticated.');
      }
    } catch (error) {
      this.logger.error('Error on user athentication: ', error);
    }
  }

  private async getSkillIdOutboundCall(): Promise<number | null> {
    var skills = await this.sdkAcdAgent.cxoneAcd.getAgentSkills();

    this.logger.info('Skills retrieved: ', skills);

    for (const skill of skills) {
      if (skill.isOutbound === true && skill.typeId === 4) {
        return skill.skillId;
      }
    }
    return null;
  }

  private HandleClickToActEvent(event: any) {
    this.logger.info('Click event received from Dynamics. ', event);

    const clickToCallEvent = this.jsonConverterUtils.JsonParsed(
      event?.data?.messageData || '',
    ) as {
      value?: string;
      entityId?: string;
    };
    const telephoneFromEvent = clickToCallEvent?.value || '';
    if (!telephoneFromEvent) {
      this.logger.warn(
        'Invalid click-to-act payload received from Dynamics.',
        event?.data?.messageData,
      );
      return;
    }

    let telephone = telephoneFromEvent;
    const entityId = clickToCallEvent?.entityId || '';

    this.logger.info(
      'Telephone received form dynamics: ' + telephone,
      'EntityId: ' + entityId,
    );

    if (
      IframeEnvironment[
        this.localStorageUtils.safeGetItem(
          'iframeEnvironment',
        ) as keyof typeof IframeEnvironment
      ] === IframeEnvironment.Dev
    ) {
      let telephoneManipulated = telephone.substring(3);
      this.logger.info('Telephone manipulated to: ' + telephoneManipulated);
      telephone = telephoneManipulated;
    }

    this.dialCallButtonClick(telephone);
  }

  private async dialCallButtonClick(phoneNumber: string) {
    var skillOutbound = await this.getSkillIdOutboundCall();
    this.logger.info('Outbound skill:', skillOutbound);

    if (skillOutbound == null) {
      this.logger.warn(
        'Cancelling dialing. Agent does not have an outbound voice skill.',
      );
      return;
    }

    var skillId = parseInt(skillOutbound.toString(), 10);

    this.logger.info('Dialing to ' + phoneNumber + ' from skillId ' + skillId);

    this.sdkAcdAgent.cxoneAcd.contactManager.voiceService
      .dialPhone({ skillId: skillId, phoneNumber: phoneNumber })
      .then((res) => {
        this.logger.info(
          'Dialled Given number and dial phone api successfully called: ',
          res,
        );
      })
      .catch((e) => {
        this.logger.error('Error: ', e);
      });
  }

  async getWebRtcServiceUrls() {
    const agentSettings =
      (await CXoneClient.instance.agentSetting.getAgentSettings()) as AgentSettings;
    const getUserInfo =
      (await CXoneClient.instance.cxoneUser.getUserDetails()) as UserInfo;
    if (!agentSettings && getUserInfo.icAgentId) {
      return;
    }

    return {
      agentId: getUserInfo.icAgentId,
      agentSettings: agentSettings,
      userInfo: getUserInfo,
    };
  }

  private async InsertTimeLineDynamics(event: CXoneVoiceContact) {
    if (typeof (window as any).Microsoft !== 'undefined') {
      const environment = this.jsonConverterUtils.JsonParsed(
        await (window as any).Microsoft.CIFramework.getEnvironment(),
      ) as {
        userId?: string;
        id?: string;
      };
      if (!environment?.userId || !environment?.id) {
        this.logger.warn('Invalid CIF environment payload.');
        return;
      }

      let userId = environment.userId.slice(1, -1);
      let startTime = event.startTime;
      let endTime = new Date();
      let callDuration: number = Math.floor(
        Math.abs(endTime.getTime() - startTime.getTime()) / 60000,
      );

      const data = {
        subject: 'Chamada efetuada às: ' + new Date().toLocaleString(),
        phonenumber: event.dnis,
        directioncode: true,
        actualstart: startTime.toISOString(),
        actualend: endTime.toISOString(),
        'regardingobjectid_contact@odata.bind':
          '/contacts(' + environment.id + ')',
        statecode: 0,
        statuscode: 1,
        actualdurationminutes: callDuration,
        phonecall_activity_parties: [
          {
            'partyid_contact@odata.bind': '/systemusers(' + userId + ')',
            participationtypemask: 1,
          },
          {
            'partyid_contact@odata.bind': '/contacts(' + environment.id + ')',
            participationtypemask: 2,
          },
        ],
      };
      this.logger.info('Data sent to create record: ', JSON.stringify(data));

      try {
        await (window as any).Microsoft.CIFramework.createRecord(
          'phonecall',
          JSON.stringify(data),
        ).then(() => {
          this.logger.info(
            'Event sent to create record successfully in Dynamics: ',
          );
        });
      } catch (error: any) {
        this.logger.error('Error on sent create record', error);
      }
    } else {
      this.logger.warn('CIF is not ready yet.');
    }
  }

  private async createDigitalRecordInDynamcis(
    payload: Record<string, unknown>,
    interactionId: string,
  ) {
    const createRecordObject = JSON.stringify({
      itseg_tipo: 10,
      itseg_objetojson: JSON.stringify(payload),
    });

    const user = getUserIfoInLocalStorage();

    quickWebLogger.logger.info('Dados para criação do lead no dynamics.', {
      details: {
        user,
        interactionId,
        dynamicsData: createRecordObject,
      },
    });

    await (window as any).Microsoft.CIFramework.createRecord(
      'itseg_logssegurospf',
      createRecordObject,
    );
  }

  private async raiseContactFocusEventOnDynamics(
    attachData: {
      u_json: Record<string, string>;
    },
    interactionId: string,
  ) {
    const uJson = attachData['u_json'] ?? attachData;
    const nomeCompleto = uJson['NOME_COMPLETO'] || 'Cliente';
    const telefone = uJson['TELEFONE'] || '';
    const contactId = (uJson['CPF_CNPJ'] ?? '').replace(/[{}]/g, '');

    const origem = (uJson['ORIGEM'] ?? '').trim().toLowerCase();
    const origemTitulo = TITULO_POR_ORIGEM[origem];

    this.logger.info('Origem recebida: ', origem, '| Título: ', origemTitulo);

    if (!origemTitulo) {
      const userSemOrigem = getUserIfoInLocalStorage();

      this.logger.warn(
        'Notificação não enviada: ORIGEM ausente ou não mapeada no U_JSON. InteractionId: ',
        interactionId,
      );

      quickWebLogger.logger.warn(
        'Notificação não enviada ao dynamics: ORIGEM ausente ou não mapeada no U_JSON.',
        {
          details: {
            user: userSemOrigem,
            interactionId,
            origem,
          },
        },
      );

      return;
    }

    const channelProviderVariables =
      await this.dynamics.loadDynamicsEnviromentVariables();

    const userId = channelProviderVariables?.userId
      ? channelProviderVariables?.userId.replace(/[{}]/g, '')
      : '';

    const body = `${nomeCompleto}\n${telefone}\n\n\nVerifique se o lead já está disponível para atuação.`;

    const actionsPayload = {
      actions: [
        {
          title: 'Abrir Raio-X',
          data: {
            navigationTarget: 'inline',
            url: `?pagetype=entityrecord&etn=contact&id=${contactId}`,
          },
        },
      ],
    };

    const raiseContactDataStrigify = JSON.stringify({
      title: `Aguardando contato - ${origemTitulo}`,
      body,
      'ownerid@odata.bind': `/systemusers(${userId})`,
      icontype: 100000001,
      toasttype: 200000000,
      data: JSON.stringify(actionsPayload),
    });

    this.logger.info(
      'payload de envio para a criação de notificação  no dynamics',
      raiseContactDataStrigify,
    );

    const user = getUserIfoInLocalStorage();

    quickWebLogger.logger.info(
      'Dados para criação de notificação no dynamics.',
      {
        details: {
          user,
          interactionId,
          dynamicsData: raiseContactDataStrigify,
        },
      },
    );
    await (window as any).Microsoft.CIFramework.createRecord(
      'appnotification',
      raiseContactDataStrigify,
    );
  }

  private async closeDynamicLeadTimeLine(payload: Record<string, unknown>) {
    const createRecordObject = JSON.stringify({
      itseg_tipo: 11,
      itseg_objetojson: JSON.stringify(payload),
    });

    await (window as any).Microsoft.CIFramework.createRecord(
      'itseg_logssegurospf',
      createRecordObject,
    );
  }

  private messageHandler = (event: MessageEvent) => {
    this.logger.info(event);
    if (event.data.messageType === 'onclicktoact') {
      this.HandleClickToActEvent(event);
    }
  };
}
